import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { FormGroup, FormGroupProps, FormGroupType } from "../misc/formGroup";

interface FormNumberProps extends Controls.ControlNumberProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    groupType?: FormGroupType | undefined;
    labelWidth?: string | undefined;
}

const ComponentProps = (props: FormNumberProps): Controls.ControlNumberProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;
    delete componentProps.labelWidth;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormNumberProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,
        labelWidth: props.labelWidth,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormNumber: React.FC<Controls.ControlNumberProps> = (props) => {
    const styles: IFormStyles = useFormStyles();
    
    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlNumber {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};
